export default __webpack_public_path__ + "static/media/dds5168b-4.4c6ccfc1.png";